import { BaseGameState } from "onearm";

/**
 * Development sandbox state for testing and debugging game components.
 * Accessed after GameIntroState - useful for isolated component testing.
 * @extends BaseGameState
 */
export class SandboxState extends BaseGameState {
    enter() {
        console.log("[SandboxState] Entered sandbox mode");

        const gameConfig = this.services.get("gameConfig");


        this.scenes.show("GameBackground");

        this.hud = this.scenes.add("HUDScene");
        this.scenes.show("HUDScene");

        this.reels = this.scenes.add("ReelsScene", {
            root: this.hud.getReelsPlaceholder(),
            gameConfig,
            lastSpin: this.gameLogic.lastSpin,
        });
        this.scenes.show("ReelsScene");

    }

    /**
     * Exits sandbox and continues to normal game flow
     */
    continueToGame() {
        this.owner.goTo("GameState");
    }

    exit() {
        super.exit();
        console.log("[SandboxState] Exiting sandbox mode");
    }
}


